import React from 'react';
import { Grid } from '@ntuctech/devex-tangram';
import styled from 'styled-components';
import QRCode from 'qrcode';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import CopyPromoCode from './CopyPromoCode';
import { DEFAULT_TITLE } from '../../constants';

const QRSection = styled.div`
  h3 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    color: #333333;
  }
  h6 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }
  h2 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 23px;
    line-height: 32px;
    color: #333333;
    margin-top: 15px;
  }
  span {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #1454b8;
  }
  img {
    position: relative;
    top: -25px;
  }
`;

const RmvInnerPad = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    > div:nth-child(1) {
      padding: 0 0;
    }
    > div:nth-child(1) > div:nth-child(1) {
      padding-left: 0;
    }
    > div:nth-child(1) > div:nth-last-child(1) {
      padding-right: 0;
    }
  }
`;

const StyledQrCodeWrapper = styled.div`
  position: relative;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  canvas {
    position: relative;
    z-index: 20;
  }

  &[data-expired='true']:after {
    content: 'Expired :(';
    position: absolute;
    top: 40%;
    left: 30%;
    font-size: 1.4375rem;
    color: var(--error-color);
    font-weight: 700;
    border: 0.3rem solid var(--error-color);
    border-radius: 0.25rem;
    padding: 0.5rem;
  }

  &[data-depleted='true']:after {
    content: 'Used :)';
    position: absolute;
    top: 40%;
    left: 33%;
    font-size: 1.4375rem;
    color: var(--error-color);
    font-weight: 700;
    border: 0.3rem solid var(--error-color);
    border-radius: 0.25rem;
    padding: 0.5rem;
  }
  &[data-error-type] {
    &:before {
      content: attr(data-error-type);
      position: absolute;
      top: 25%;
      left: 35%;
      color: var(--error-color);
      font-size: 2.75rem;
      font-weight: 900;
      z-index: 1;
    }

    &:after {
      content: attr(data-error-message);
      position: absolute;
      top: 42%;
      left: 20%;
      color: var(--error-color);
      font-size: 1rem;
      line-height: 1.5;
      font-weight: 700;
      z-index: 1;
      width: 10rem;
      text-align: center;
    }
  }
`;

const StyledCanvasWrapper = styled.div`
  text-align: center;
  &[data-faded='true'] {
    opacity: 0.1;
  }

  ${SCREEN_SIZE.Below.MobileL} {
    padding: 2.5rem 2rem 2.75rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    &[data-error-type] {
      padding-bottom: 2.5rem;
    }
  }
`;

const VoucherCode = (props) => {
  const { code, hasDepleted, error, hasExpired } = props;
  const canvasRef = React.useRef();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 600);

  React.useEffect(() => {
    const updateWindowDimensions = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener('resize', updateWindowDimensions);

    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  const QRCodeComponent = (
    <Grid item s={12} style={{ textAlign: isMobile ? 'center' : 'left', padding: '8px 0 0' }}>
      <h2>{code}</h2>
      <CopyPromoCode
        code={code}
        hasDepleted={hasDepleted}
        hasExpired={hasExpired}
        isMobile={isMobile}
      />
    </Grid>
  );

  React.useEffect(() => {
    QRCode.toCanvas(canvasRef.current, code || error.message, {
      width: 200,
      margin: 0,
    });
  });
  return (
    <QRSection>
      <RmvInnerPad>
        <Grid container>
          <Grid item s={8}>
            {!error && (
              <>
                <h3>Use {DEFAULT_TITLE} now</h3>
                <h6>Scan QR code at payment counters or copy this codeto shop online.</h6>
                {!isMobile ? QRCodeComponent : ''}
              </>
            )}
          </Grid>
          <Grid item s={4}>
            {/* <img {...QRCode} alt="" width="100%" height="auto" /> */}
            <StyledQrCodeWrapper
              data-depleted={hasDepleted}
              data-error-message={error && error.message}
              data-error-type={error && error.type}
              data-expired={hasExpired}
              data-testid="voucher-box"
            >
              {/* <img alt="white bg" src={WhiteBg} /> */}
              <StyledCanvasWrapper
                data-faded={!!error || hasExpired || hasDepleted}
                data-error-type={error && error.type}
              >
                <canvas ref={canvasRef} />
              </StyledCanvasWrapper>
            </StyledQrCodeWrapper>
          </Grid>
          {isMobile ? QRCodeComponent : ''}
        </Grid>
      </RmvInnerPad>
    </QRSection>
  );
};

export default VoucherCode;
